import { useState } from 'react';
import { SCREEN_TIME_OPTIONS } from '../../lib/detoxPrompts';

export default function DetoxEnrollment({ communityCount, onEnroll }) {
  const [screenTime, setScreenTime] = useState('');
  const [loading, setLoading] = useState(false);

  const handleStart = async () => {
    if (!screenTime) return;
    setLoading(true);
    await onEnroll(screenTime);
    setLoading(false);
  };

  return (
    <div className="detox-enrollment">
      <div className="detox-hero">
        <div className="detox-hero-emoji">🧘</div>
        <h1 className="detox-hero-title">Desafio Detox<br />7 Dias</h1>
        <p className="detox-hero-subtitle">
          Sete dias para descobrir quem você é quando o feed não define sua atenção.
        </p>
      </div>

      {communityCount > 0 && (
        <div className="detox-community-pill">
          🔥 {communityCount} {communityCount === 1 ? 'pessoa está' : 'pessoas estão'} no detox agora
        </div>
      )}

      <div className="card">
        <p className="card-title">Antes de começar</p>
        <p className="detox-question">
          📱 Qual é o seu tempo médio nas redes sociais <strong>hoje</strong>?
        </p>
        <p style={{ fontSize: '.85rem', color: 'var(--text-muted)', marginBottom: 12 }}>
          Vamos comparar com o seu tempo no Dia 7 para você ver o resultado real.
        </p>
        <div className="screen-time-options">
          {SCREEN_TIME_OPTIONS.map(opt => (
            <button
              key={opt.value}
              className={`screen-time-btn ${screenTime === opt.value ? 'selected' : ''}`}
              onClick={() => setScreenTime(opt.value)}
              type="button"
            >
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      <div className="card detox-what-to-expect">
        <p className="card-title">O que esperar</p>
        <ul className="detox-list">
          <li>📝 Um prompt diferente por dia para guiar sua escrita</li>
          <li>✅ Check-in diário sobre como foi ficar sem redes</li>
          <li>📊 Acompanhe quantas vezes sentiu vontade de abrir o feed</li>
          <li>🧘 Badge exclusivo <strong>Mente Livre</strong> ao completar</li>
          <li>📄 Relatório personalizado do seu detox no final</li>
        </ul>
      </div>

      <button
        className="btn btn-primary detox-start-btn"
        onClick={handleStart}
        disabled={!screenTime || loading}
      >
        {loading ? 'Iniciando...' : 'Começar o Detox 🚀'}
      </button>
    </div>
  );
}
